export default "https://cdn-web.disco.co/alumni-space-aaf571b1d293f56ac4932dacb72f27e9.png";